export const EVENT_TEMPLATE_OWNERS = {
  DEFAULT: 'default',
  OUTBOUND: 'outbound',
  CLIENT: 'CL_',
}

export const EVENT_TEMPLATE_TARGETS = {
  DEFAULT: 'default',
  CLIENT_APP: 'client-app',
}